let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hDqMP")).then(() => parcelRequire('kxeT5'));